import '@/styles/global.css'
import ReactDom from 'react-dom/client'
import { AppRouter } from '@/router/router'

const rootEl = document.getElementById('root')
if (rootEl) {
  const root = ReactDom.createRoot(rootEl)
  root.render(<AppRouter />)
}
